import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { getDefaultStore } from "jotai";
import { Toaster } from "sonner";
import { isAuthenticatedAtom } from "@tubo/store";
import { useTheme } from "@client/hooks/use-theme";

export const Route = createFileRoute("/_workspace")({
  beforeLoad: ({ location }) => {
    const store = getDefaultStore();
    if (!store.get(isAuthenticatedAtom)) {
      throw redirect({
        to: "/login",
        search: { redirect: location.href },
      });
    }
  },
  component: WorkspaceLayout,
});

function WorkspaceLayout() {
  const { resolvedTheme } = useTheme();

  return (
    <div className="h-screen overflow-hidden">
      <Outlet />
      <Toaster
        position="top-center"
        theme={resolvedTheme}
        closeButton
        toastOptions={{
          duration: 5000,
          classNames: {
            toast: "border shadow-lg",
            success: "border-success",
            error: "border-error",
            warning: "border-warning",
            info: "border-info",
          },
        }}
      />
    </div>
  );
}
